<style lang="scss" scoped>
  @import '../css/sub.scss';

  .form-group {
    width: 100%;

    &.half {
      width: calc(50% - 10px);

      .input-area {
        flex-direction: row;
        flex-wrap: wrap;
      }

      &.right {
        margin-left: 20px;
      }

      .tit {
        width: 112px;
      }

      .desc {
        width: calc(100% - 112px);

        &.chk {
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .chk-area {
            width: 110px;
            margin: 0;
          }

          .default-input {
            width: calc(100% - 110px);
          }
        }
      }
    }

    .input-area {
      width: 100%;
    }
  }

  .choice-inform {
    display: flex;
    flex-wrap: wrap;
  }
</style>

<template>
  <div class="urban-asset">
    <vuejs-search-address name="address" v-model="info.address" :show="layer_pop_post" @close="getPostcode"></vuejs-search-address>
    <div class="urban-sub" style="padding:0;">
      <div class="column-container">
        <form @submit.prevent="submit">
          <div class="column-row">
            <h3 class="column-tit">매물 종류</h3>
            <div class="sub-contents">
              <div class="btn-area">
                <toggle-btn v-for="(button, index) in this.typeEstate" :is-active="button.isActive" :key="index"
                            :tit="button.codeNm" v-on:activate="activateButton(button)"></toggle-btn>
              </div>
            </div>
          </div>
          <div class="column-row">
            <h3 class="column-tit">필수기재정보</h3>
            <div class="sub-contents">
              <div class="form-group" :class="{ 'form-group-error': $v.address.$error }">
                <div class="input-area">
                  <div class="tit">
                    <label class="form-label" for="user-address">주소<span class="require">*</span></label>
                  </div>
                  <div class="desc search">
                    <input
                      class="default-input form-input"
                      type="text"
                      disabled
                      :value="info.address"
                      id="user-address"
                      @click="showModal()"
                      placeholder="찾기 버튼을 눌러 주소를 검색해주세요.">
                    <button type="button" class="default-btn address-search" @click="showModal()">찾기</button>
                    <!-- <vuejs-address id="address" class="w-100per" name="address" v-model="info.address"
                                   :show="layer_pop_post" @close="getPostcode"></vuejs-address> -->
                    <div class="notice">
                      <p class="error" v-if="info.address === ''">주소를 입력해주세요.</p>
                      <ul class="notice-list">
                        <li>- 주소와 단지명 모두 검색이 가능합니다.</li>
                        <li>- 주소 입력 시에는 동/읍/면 으로 검색해 주세요. 예) 자곡동, 동읍면, 신월읍</li>
                        <li>- 검색할 때에는 동/읍/면 이름과 단지 명을 함께 입력하면 좀 더 편하게 주소를 검색할 수 있습니다. 예) 계산동 하이베라스</li>
                        <li class="default-color">- 주소 입력 후 수정 불가합니다. 수정을 원할 시 고객센터에 연락 바랍니다.</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="input-area">
                  <div class="tit">
                    <label class="form-label" for="user-detail">상세주소</label>
                  </div>
                  <div class="desc">
                    <input
                      class="default-input form-input"
                      type="text"
                      v-model.trim="detailAddress"
                      id="user-detail"
                      placeholder="상세주소">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column-row">
            <h3 class="column-tit">사진등록</h3>
            <div class="sub-contents">
              <div class="file-area">
                <VueFileAgent
                  ref="vueFileAgent"
                  :theme="'grid'"
                  :multiple="true"
                  :deletable="true"
                  :meta="true"
                  :accept="'image/*'"
                  :maxSize="'10MB'"
                  :maxFiles="5"
                  :helpText="'첨부할 파일을 마우스로 끌어서 추가할 수 있습니다.'"
                  :errorText="{
                  type: '이미지만 업로드가 가능합니다.',
                  size: '사진크기는 10MB 를 넘을 수 없습니다.',
                }"
                  @select="filesSelected($event)"
                  @beforedelete="onBeforeDelete($event)"
                  @delete="fileDeleted($event)"
                  @upload="onUpload($event)"
                  @upload:error="onUploadError($event)"
                  v-model="fileRecords"
                ></VueFileAgent>
              </div>
              <ul class="file-notice-list">
                <li>- 사진 최대 5장 까지 등록할 수 있습니다. <strong class="default-color">사진 1장은 필수</strong>이며 나머지 사진 4장은 자유등록입니다.
                </li>
                <li>- 직접 찍은 실제 방 사진의 원본을 등록해야 합니다.</li>
              </ul>
            </div>
          </div>
          <div class="column-row">
            <div class="sub-contents">
              <div class="btn-area sell-kind">
                <toggle-sell v-for="(button, index) in this.typeDeal" :is-active="button.isActive" :key="index"
                             :tit="button.codeNm" v-on:activate="activateSell(button)"></toggle-sell>
              </div>
              <div class="form-group" v-if="this.typeDealCode === '002'">
                <div class="input-area">
                  <div class="tit">
                    <label class="form-label" for="user-deposit">보증금</label>
                  </div>
                  <div class="desc">
                    <input
                      class="default-input form-input"
                      type="text"
                      id="user-deposit"
                      v-model="depositEstate"
                      placeholder="단위: 만원">
                    <div class="notice">
                      <ul class="notice-list">
                        <li>- 무보증일 경우, 한 달 월세를 입력하세요.<span class="amount">입력금액: <span>{{ReplaceComma(depositEstate.replace(/[^0-9.]/g, '')*10000)}}</span>원</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="input-area">
                  <div class="tit">
                    <label class="form-label" for="user-rent">
                      <span v-if="this.typeDealCode === '001'">매매가</span>
                      <span v-else>월세</span>
                    </label>
                  </div>
                  <div class="desc">
                    <input
                      class="default-input form-input"
                      type="text"
                      id="user-rent"
                      v-model="priceEstate"
                      placeholder="단위 : 원">
                    <div class="notice">
                      <ul class="notice-list">
                        <li><span v-if="this.typeDealCode === '002'">- 전세일 경우 숫자 0을 입력하세요.</span><span class="amount">입력금액: <span>{{ReplaceComma(priceEstate.replace(/[^0-9.]/g, ''))}}</span>원</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="input-area">
                  <div class="tit">
                    <label class="form-label" for="user-cost">관리비</label>
                  </div>
                  <div class="desc">
                    <input
                      class="default-input form-input"
                      type="text"
                      id="user-cost"
                      v-model="adepriceEstate"
                      placeholder="관리비">
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="this.typeEstateCode === '007' || this.typeEstateCode === '008'">
                <div class="input-area">
                  <div class="tit">
                    <label class="form-label" for="first-price-sale">최초 분양가</label>
                  </div>
                  <div class="desc">
                    <input
                      class="default-input form-input"
                      type="text"
                      id="first-price-sale"
                      v-model="firstPriceEstate"
                      placeholder="최초 분양가">
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="this.typeEstateCode === '007' || this.typeEstateCode === '008'">
                <div class="input-area">
                  <div class="tit">
                    <label class="form-label" for="user-desc-estate">회원 혜택</label>
                  </div>
                  <div class="desc">
                    <textarea name="" cols="30" rows="10" class="default-textarea" id="user-desc-estate"
                              v-model="descEstate"></textarea>
                  </div>
                </div>
              </div>
              <div class="choice-inform" v-if="this.typeEstateCode === '009'">
                <div class="form-group half">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-009-1">공모 기간</label>
                    </div>
                    <div class="desc">
                      <input
                        class="default-input form-input"
                        type="text"
                        id="user-009-1"
                        v-model="startDate"
                        placeholder="시작: 년월일">
                    </div>
                  </div>
                </div>
              <div class="form-group half right">
                <div class="input-area">
                  <div class="tit">
                    <label class="form-label" for="user-009-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;~&nbsp;&nbsp;&nbsp;&nbsp;</label>
                  </div>
                  <div class="desc mr-0">
                    <input
                      class="default-input form-input"
                      type="text"
                      id="user-009-2"
                      v-model="endDate"
                      placeholder="마감: 년월일">
                  </div>
                </div>
              </div>
              </div>
              <div class="form-group" v-if="this.typeEstateCode === '009'">
                <div class="input-area">
                  <div class="tit">
                    <label class="form-label" for="user-009-3">공모 금액</label>
                  </div>
                  <div class="desc">
                    <input
                      class="default-input form-input"
                      type="text"
                      id="user-009-3"
                      v-model="offeringAmount"
                      placeholder="단위:만원">
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="this.typeEstateCode === '009'">
                <div class="input-area">
                  <div class="tit">
                    <label class="form-label" for="user-009-4">공모가</label>
                  </div>
                  <div class="desc">
                    <input
                      class="default-input form-input"
                      type="text"
                      id="user-009-4"
                      v-model="offeringPrice"
                      placeholder="단위:만원">
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="this.typeEstateCode === '009'">
                <div class="input-area">
                  <div class="tit">
                    <label class="form-label" for="user-009-5">수익률</label>
                  </div>
                  <div class="desc">
                    <input
                      class="default-input form-input"
                      type="text"
                      id="user-009-5"
                      v-model="returnAmount"
                      placeholder="단위:%">
                  </div>
                </div>
              </div>
              <div class="form-group rg-btn-area">
                <div class="input-area">
                  <button class="default-btn registration-btn" type="submit">매물등록 및 저장</button>
                </div>
              </div>
            </div>
          </div>
          <div class="column-row">
            <h3 class="blind">선택입력정보</h3>
            <div class="sub-contents">
              <button type="button" class="choice-btn" @click="choiceFilter()" :class="{active: chActive}">선택입력정보<i
                class="icon"></i></button>
              <div class="choice-inform" v-if="chActive">
                <div class="form-group">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label">크기</label>
                    </div>
                    <div class="desc size-desc">
                      <span class="size-txt">전용면적(대지면적)</span>
                      <input
                        class="default-input"
                        type="text"
                        v-model="eaEstate">
                      <span class="size-unit">㎡      =</span>
                      <input
                        class="default-input form-input"
                        type="text"
                        disabled
                        v-model="eaEstate_c">
                      <span class="size-txt last">계약면적(건물면적)</span>
                      <input
                        class="default-input"
                        type="text"
                        v-model="caEstate">
                      <span class="size-unit">㎡      =</span>
                      <input
                        class="default-input form-input"
                        type="text"
                        disabled
                        v-model="caEstate_c">
                    </div>
                  </div>
                </div>
                <div class="form-group half">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-ch01">해당층/건물층</label>
                    </div>
                    <div class="desc">
                      <input
                        class="default-input form-input"
                        type="text"
                        id="user-ch01"
                        v-model="floorEstate"
                        placeholder="ex) 30층">
                    </div>
                  </div>
                </div>
                <div class="form-group half right">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-ch02">준공년도</label>
                    </div>
                    <div class="desc">
                      <input
                        class="default-input form-input"
                        type="text"
                        id="user-ch02"
                        v-model="cdateEstate"
                        maxlength="15"
                        placeholder="ex) 2020년">
                    </div>
                  </div>
                </div>
                <div class="form-group half">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-ch03">냉·난방종류</label>
                    </div>
                    <div class="desc">
                      <input
                        class="default-input form-input"
                        type="text"
                        v-model="typeCH"
                        id="user-ch03">
                    </div>
                  </div>
                </div>
                <div class="form-group half right">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-ch04">방향</label>
                    </div>
                    <div class="desc">
                      <input
                        class="default-input form-input"
                        type="text"
                        v-model="directionEstate"
                        id="user-ch04">
                    </div>
                  </div>
                </div>
                <div class="form-group half">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-ch06">엘리베이터</label>
                    </div>
                    <div class="desc">
                      <input
                        class="default-input form-input"
                        type="text"
                        id="user-ch06"
                        v-model="flagElevator"
                        placeholder="ex) 가능">
                    </div>
                  </div>
                </div>
                <div class="form-group half right">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-ch05">주차가능대수</label>
                    </div>
                    <div class="desc chk">
                      <div class="chk-area text-left">
                        <input type="checkbox" class="default-chk" id="parking-chk" v-model="chkParking"><label
                        for="parking-chk" class="default-chk-label default-color">주차불가</label>
                      </div>
                      <input
                        class="default-input form-input"
                        type="text"
                        id="user-ch05"
                        v-model="numParking"
                        placeholder="ex) 1대">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-ch07">입주가능일</label>
                    </div>
                    <div class="desc">
                      <input
                        class="default-input form-input"
                        type="text"
                        id="user-ch07"
                        v-model="dateMoveIn"
                        maxlength="10"
                        placeholder="ex) 2020.01.01">
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-ch08">상세설명</label>
                    </div>
                    <div class="desc">
                      <textarea name="" cols="30" rows="10" class="default-textarea" id="user-ch08"
                                v-model="descEstate"></textarea>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="input-area">
                    <div class="tit">
                      <label class="form-label" for="user-ch09">영상 URL</label>
                    </div>
                    <div class="desc">
                      <input
                        class="default-input form-input"
                        type="text"
                        id="user-ch09"
                        v-model="mediaURL"
                        placeholder="해당 매물의 영상 url을 기입해주세요.">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <form name="form1" method="post">
    </form>
  </div>
</template>

<script>
import ToggleBtn from '@/components/ToggleBtn'
import DaumPostcode from '@/components/DaumPostcode'
import {required, sameAs} from 'vuelidate/lib/validators'
import {mapGetters} from 'vuex'
import LandUsePopupVue from '../components/LandUsePopup.vue'

var status = ''

export default {
  name: 'AdminRegEstate',
  components: {
    'toggle-btn': ToggleBtn,
    'toggle-sell': ToggleBtn,
    'vuejs-address': DaumPostcode,
    'vuejs-search-address': LandUsePopupVue
  },
  data () {
    return {
      layer_pop_post: false,
      info: {
        address: '',
        address_detail: ''
      },
      fileRecordsForDelete: [],
      fileRecords: [],
      imgUrl: this.$store.state.common.urlpath,
      uploadUrl: this.$store.state.common.urlpath + '/api/fileupload/process',
      uploadHeaders: {'X-Test-Header': 'vue-file-agent'},
      fileRecordsForUpload: [], // maintain an upload queue
      typeDealCode: '',
      typeEstateCode: '',
      depositEstate: '',
      priceEstate: '',
      firstPriceEstate: '',
      adepriceEstate: '',
      address: '',
      detailAddress: '',
      terms: '',
      eaEstate: '',
      caEstate: '',
      eaEstate_c: '',
      caEstate_c: '',
      floorEstate: '',
      cdateEstate: '',
      typeCH: '',
      directionEstate: '',
      numParking: '',
      flagParking: 'O',
      chkParking: false,
      flagElevator: '',
      dateMoveIn: '',
      regdateEstate: '',
      descEstate: '',
      mediaURL: '',
      chActive: false,
      AtFile: [],
      tmpFileid: 0,
      startDate: '',
      endDate: '',
      offeringAmount: '',
      offeringPrice: '',
      returnAmount: ''
    }
  },
  validations: {
    address: {
      required
    },
    terms: {
      required,
      sameAs: sameAs(() => true)
    }
  },
  created () {
    // this.$store.dispatch('apiEtcCodelists', {'Code': '001', 'DeCode': ''})
    // this.$store.dispatch('apiEtcCodelists', {'Code': '002', 'DeCode': ''})
  },
  mounted () {
    this.$store.dispatch('apiEtcCodelists', {'Code': '001', 'DeCode': ''})
    this.$store.dispatch('apiEtcCodelists', {'Code': '002', 'DeCode': ''})
    this.setInit()
    // console.log('hello registration FREE', this.typeDeal)
  },
  watch: {
    depositEstate () {
      // immediate = true,
      this.depositEstate = this.ReplaceComma(this.depositEstate)
    },
    priceEstate () {
      this.priceEstate = this.ReplaceComma(this.priceEstate)
    },
    adepriceEstate () {
      this.adepriceEstate = this.ReplaceComma(this.adepriceEstate)
    },
    typeEstate () {
      this.$set(this.typeEstate[0], 'isActive', true)
      for (var i = 1; i < this.typeEstate.length; i++) {
        this.$set(this.typeEstate[i], 'isActive', false)
      }
      this.typeEstateCode = this.typeEstate[0].deCode
    },
    typeDeal () {
      this.$set(this.typeDeal[0], 'isActive', true)
      for (let i = 1; i < this.typeDeal.length; i++) {
        this.$set(this.typeDeal[i], 'isActive', false)
      }
      this.typeDealCode = this.typeDeal[0].deCode
      console.log('typeDeal', this.typeDealCode)
    },
    eaEstate () {
      const num = this.eaEstate.toString().replace(/[^0-9.]/g, '')
      if (num.includes('.')) {
        this.eaEstate = num.split('.')[0] + '.' + this.eaEstate.toString().split('.')[1].slice(0, 2)
      } else {
        this.eaEstate = num
      }
      this.eaEstate_c = num / 3.3058
    },
    caEstate () {
      const num = this.caEstate.toString().replace(/[^0-9.]/g, '')
      if (num.includes('.')) {
        this.caEstate = num.split('.')[0] + '.' + this.caEstate.toString().split('.')[1].slice(0, 2)
      } else {
        this.caEstate = num
      }
      this.caEstate_c = num / 3.3058
    },
    eaEstate_c () {
      this.eaEstate_c = parseFloat(this.eaEstate_c.toFixed(2))
    },
    caEstate_c () {
      this.caEstate_c = parseFloat(this.caEstate_c.toFixed(2))
    },
    numParking () {
      if (this.flagParking === 'O') {
        this.numParking = this.numParking
      } else {
        this.numParking = ''
      }
    },
    chkParking () {
      if (this.chkParking === true) {
        this.numParking = ''
        this.flagParking = 'X'
      } else {
        this.flagParking = 'O'
      }
    },
    idEstate () {
      this.uploadFiles()
    }
  },
  methods: {
    setInit: function () {
    },
    showModal: function () {
      this.layer_pop_post = true
    },
    getPostcode: function (show, postcode, adress) {
      if (show) {
        this.layer_pop_post = false
        // this.info.address = adress
        // this.info.postcode = postcode
        // this.info.address_detail = ''
        this.address = show
      } else {
        this.layer_pop_post = false
      }
    },
    activateButton: function (activatedButton) {
      for (let i = 0; i < this.typeEstate.length; i++) {
        const button = this.typeEstate[i]
        button.isActive = button === activatedButton
      }
      this.typeEstateCode = activatedButton.deCode
    },
    activateSell: function (activatedButton) {
      for (let i = 0; i < this.typeDeal.length; i++) {
        const button = this.typeDeal[i]
        button.isActive = button === activatedButton
      }
      this.typeDealCode = activatedButton.deCode
    },
    choiceFilter: function () {
      this.chActive = !this.chActive
    },
    uploadFiles: function () {
      if (sessionStorage.getItem('token') != null) {
        let idEstate = this.idEstate
        this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, this.fileRecordsForUpload, function createFormData (fileData) {
          var formData = new FormData()
          formData.append('id', idEstate)
          formData.append('type', '01')
          formData.append('file', fileData.file)
          return formData
        }).then(() => {
          if (status === 'U') {
            this.fileDataUpload()
          }
        })
      } else {
        alert('세션 만료 또는 잘못된 접근 입니다.')
        this.$router.push('/Login')
      }
    },
    filesSelected: function (fileRecordsNewlySelected) {
      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error)
      this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords)
    },
    onBeforeDelete: function (fileRecord) {
      const i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        // console.log('fileRecordsForDelete = 111')
        if (this.fileRecordsForDelete.indexOf(fileRecord) === -1) {
          this.fileRecordsForDelete.push(fileRecord)
          // console.log('fileRecordsForDelete = ' + JSON.stringify(this.fileRecordsForDelete))
        }
        this.fileRecordsForUpload.splice(i, 1)
        const k = this.fileRecords.indexOf(fileRecord)
        if (k !== -1) {
          // console.log('fileRecordsForDelete = 111---2')
          this.fileRecords.splice(k, 1)
        }
      } else {
        // console.log('fileRecordsForDelete = 222')
        this.$refs.vueFileAgent.deleteFileRecord(fileRecord)
      }
    },
    fileDeleted: function (fileRecord) {
      var i = this.fileRecordsForUpload.indexOf(fileRecord)
      if (i !== -1) {
        this.fileRecordsForUpload.splice(i, 1)
      }
      /* else {
            this.deleteUploadedFile(fileRecord)
          } */
    },
    deleteUploadedFile: function () {
      // console.log('deleteUploadedFile = ' + JSON.stringify(this.fileRecordsForDelete))
      const params = {
        'deleteFiles': this.fileRecordsForDelete,
        'gubun': '01',
        'idDtFile': this.$parent.$parent.$parent.estateId
      }
      this.$store.dispatch('apiDeleteFiles', params).then(() => {
        if (this.deleteFilesRtn !== 'ok') {
          alert('file을 삭제 중 이상이 발생하였습니다.')
        } else {
          this.uploadFiles()
        }
      })
    },
    submit () {
      this.$v.$touch()
      if (this.fileRecordsForUpload[0] === undefined) {
        alert('사진은 반드시 한장이상 첨부하셔야 합니다.')
      } else {
        // console.log(this.$v)
        // console.log(this.$v.address.$invalid)
        // if (this.$v.address.$invalid) {
        if (this.info.address === '') {
          alert('필수항목을 입력해주세요.')
        } else {
          if (confirm('접수 하시겠습니까?')) {
            this.save()
          }
        }
      }
    },
    save () {
      console.log(this.adress)
      let params = {
        'typeEstate': this.typeEstateCode,
        'typeDeal': this.typeDealCode,
        'Addr': this.address,
        'detailAddr': this.detailAddress,
        'depositEstate': Number(this.depositEstate.replace(/[^0-9.]/g, '')) * 10000,
        'priceEstate': Number(this.priceEstate.replace(/[^0-9.]/g, '')),
        'adepriceEstate': Number(this.adepriceEstate.replace(/[^0-9.]/g, '')),
        'eaEstate': Number(this.eaEstate),
        'caEstate': Number(this.caEstate),
        'floorEstate': this.floorEstate,
        'cdateEstate': this.cdateEstate,
        'typeCH': this.typeCH,
        'directionEstate': this.directionEstate,
        'numParking': this.numParking,
        'flagParking': this.flagParking,
        'flagElevator': this.flagElevator,
        'dateMoveIn': this.dateMoveIn,
        'regdateEstate': this.regdateEstate,
        'descEstate': this.descEstate,
        'mediaURL': this.mediaURL,
        'regName': '',
        'regTel': '',
        'flag': 'MEMBERINSERT',
        'firstPriceEstate': Number(this.firstPriceEstate.replace(/[^0-9.]/g, '')),
        'fromDate': this.startDate ? Number(this.startDate.replace(/[^0-9.]/g, '')) : '',
        'toDate': this.endDate ? Number(this.endDate.replace(/[^0-9.]/g, '')) : '',
        'offeringAmount': Number(this.offeringAmount.replace(/[^0-9.]/g, '')) * 10000,
        'offeringPrice': Number(this.offeringPrice.replace(/[^0-9.]/g, '')) * 10000,
        'returnAmount': Number(this.returnAmount.replace(/[^0-9.]/g, '')) * 10000
      }

      // var tmpId = this.$parent.$parent.$parent.estateId
      // if (tmpId !== '') {
      //   params.idEstate = tmpId
      //   params.flag = 'UPDATE'
      //   status = 'U'
      // }
      console.log(params)
      this.$store.dispatch('apiEstate', params).then(() => {
        // this.$parent.$parent.$parent.estateSave()
        // if (status === 'U') {
        //   if (this.fileRecordsForDelete.length > 0) {
        //     this.deleteUploadedFile()
        //   } else {
        //     this.uploadFiles()
        //   }
        // } else {
        this.uploadFiles()
        // }
      })
    },
    fileDataUpload () {
      /* console.log('onUpload = ' + JSON.stringify(this.fileRecordsForUpload))
          console.log('type = ' + this.fileRecordsForUpload[0].type)
          console.log('size = ' + this.fileRecordsForUpload[0].size)
          console.log('ext = ' + this.fileRecordsForUpload[0].ext)
          console.log('lastModified = ' + this.fileRecordsForUpload[0].lastModified)
          console.log('lastModified = ' + this.fileRecordsForUpload[0].file.name) */
      this.AtFile = []
      for (let i = 0; i < this.fileRecordsForUpload.length; i++) {
        this.AtFile.push({
          'nameAtFile': this.fileRecordsForUpload[i].file.name,
          'ordAtFile': i,
          'fileType': this.fileRecordsForUpload[i].type,
          'fileSize': this.fileRecordsForUpload[i].size,
          'fileExt': this.fileRecordsForUpload[i].ext,
          'fileMody': this.fileRecordsForUpload[i].lastModified
        })
      }
      const params = {
        'Gubun': '01',
        'idAtFile': this.$parent.$parent.$parent.estateId,
        'AtFile': this.AtFile,
        'flag': 'INSERT'
      }
      // console.log(params)
      this.$store.dispatch('apiAttachedFiles', params).then(() => {
        if (this.fileFlag === 'ok') {
          this.fileRecordsForUpload = []
          this.fileRecordsForDelete = []
          this.fileRecords = []
        }
      })
    },
    onUpload (responses) {
      var i = 0
      for (var response of responses) {
        if (response.status === 200) {
          this.AtFile.push({
            'nameAtFile': this.fileRecordsForUpload[i].file.name,
            'ordAtFile': i,
            'fileType': this.fileRecordsForUpload[i].type,
            'fileSize': this.fileRecordsForUpload[i].size,
            'fileExt': this.fileRecordsForUpload[i].ext,
            'fileMody': this.fileRecordsForUpload[i].lastModified
          })
          i++
          continue
        } else {
          alert('매물 수정을 통해 파일을 재업로드 해주시길 바랍니다.')
          break
        }
      }
      const params = {
        'Gubun': '01',
        'idAtFile': this.idEstate,
        'AtFile': this.AtFile,
        'flag': 'INSERT'
      }
      // console.log(params)
      this.$store.dispatch('apiAttachedFiles', params).then((res) => {
        alert('매물이 등록되었습니다.')
        this.$router.push('/')
      }).catch(() => {
        alert('세션 만료 또는 잘못된 접근 입니다.')
      })
      this.fileRecordsForUpload = []
    },
    onUploadError (failedResponses) {
      // console.log('ERROR : ', failedResponses)
    },
    ReplaceComma (arg) {
      arg = arg.toString().replace(/[^0-9]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return arg
    },
    getFileInfo (item) {
      let obj = []
      for (var i = 0; i < item.length; i++) {
        let file = {
          name: item[i].nameAtFile,
          file: {name: item[i].nameAtFile},
          url: this.imgUrl + item[i].path,
          lastModified: item[i].fileLast,
          size: item[i].fileSize,
          type: item[i].fileType,
          ext: item[i].fileExt
        }
        obj.push(file)
      }
      return obj
    }
  },
  computed: {
    ...mapGetters({
      typeEstate: 'getEtcCode001List',
      typeDeal: 'getEtcCode002List',
      idEstate: 'getidEstate',
      deleteFilesRtn: 'getDeleteFiles'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/RegistrationFree.vue